import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NMFTAIconComponent } from '@shared/components/atoms/icon/icon.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/components/atoms/button/button.component';

export interface InactivityWarningDialogData {
  seconds: number;
  onContinue: () => void;
  onLogout: () => void;
}

@Component({
    selector: 'app-inactivity-warning-dialog',
    imports: [MatDialogModule, NMFTAIconComponent, TranslatePipe, ButtonComponent],
    templateUrl: './inactivity-warning-dialog.component.html',
    styleUrls: ['./inactivity-warning-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InactivityWarningDialogComponent {
  seconds = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InactivityWarningDialogData,
    private dialogRef: MatDialogRef<InactivityWarningDialogComponent>,
    private cdr: ChangeDetectorRef,
  ) {
    this.seconds = data.seconds ?? 0;
  }

  updateSecondsFromMs(ms: number) {
    this.seconds = Math.max(0, Math.floor(ms / 1000));
    this.cdr.markForCheck();
  }

  get timeFormatted(): string {
    const m = Math.floor(this.seconds / 60);
    const s = this.seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  }

  continue() {
    try {
      this.data.onContinue?.();
    } finally {
      this.dialogRef.close('continue');
    }
  }
  logout() {
    try {
      this.data.onLogout?.();
    } finally {
      this.dialogRef.close('logout');
    }
  }
}
